import { Alert } from "react-bootstrap";

interface BillingAlertProps {
  orgName: string;
}

const BillingAlert: React.FC<BillingAlertProps> = ({ orgName }) => {
  return (
    <div className="billing-alert-container">
      <Alert variant="danger" className="billing-alert">
        WARNING: There is <b>no active subscription</b> for the {orgName}{" "}
        organization.
        <br />
        All the CogCache Proxy API requests are currently blocked and you can’t
        add/delete/edit cache entries.
      </Alert>
    </div>
  );
};

export { BillingAlert };
